var map = {
	"./main-logo-baoding.png": "bf22",
	"./main-logo-cangzhou.png": "a7f1",
	"./main-logo-chengde.png": "af55",
	"./main-logo-handan.png": "e554",
	"./main-logo-hengshui.png": "c1c1",
	"./main-logo-langfang.png": "a730",
	"./main-logo-qinhuangdao.png": "b3ac",
	"./main-logo-shijiazhuang.png": "43a9",
	"./main-logo-tangshan.png": "5440",
	"./main-logo-zhangjiakou.png": "971d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "526c";